import { render } from "./GridMarxFaturamento.vue?vue&type=template&id=274b8f4a"
import script from "./GridMarxFaturamento.vue?vue&type=script&lang=js"
export * from "./GridMarxFaturamento.vue?vue&type=script&lang=js"

import "./GridMarxFaturamento.vue?vue&type=style&index=0&id=274b8f4a&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__